<nav class="navbar navbar-expand-lg">
  <div class="container-fluid">
    <a class="navbar-brand text-primary" href=""><h2 class="fw-bold">Synapse</h2></a>
    <button
      class="navbar-toggler"
      type="button"
      data-toggle="collapse"
      data-target="#navbarNavAltMarkup"
      aria-controls="navbarNavAltMarkup"
      aria-expanded="false"
      (click)="isCollapsed = !isCollapsed"
      [attr.aria-expanded]="!isCollapsed"
      aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse justify-content-between" id="navbarNavAltMarkup" [ngbCollapse]="isCollapsed">
      <ul class="navbar-nav me-auto mb-2 mb-lg-0 gap-2">
        <li class="nav-item">
          <a
            class="nav-link"
            routerLink="/candidates"
            routerLinkActive="text-active"
            [routerLinkActiveOptions]="{
              matrixParams: 'exact',
              queryParams: 'ignored',
              paths: 'exact',
              fragment: 'ignored'
            }"
            >Candidats</a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            routerLink="/groups"
            routerLinkActive="text-active"
            [routerLinkActiveOptions]="{
              matrixParams: 'exact',
              queryParams: 'ignored',
              paths: 'exact',
              fragment: 'ignored'
            }"
            >Groupes</a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            routerLink="/questionnaires"
            routerLinkActive="text-active"
            [routerLinkActiveOptions]="{
              matrixParams: 'exact',
              queryParams: 'ignored',
              paths: 'exact',
              fragment: 'ignored'
            }"
            >Questionnaires</a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            routerLink="/study-sheets"
            routerLinkActive="text-active"
            [routerLinkActiveOptions]="{
              matrixParams: 'exact',
              queryParams: 'ignored',
              paths: 'exact',
              fragment: 'ignored'
            }"
            >Fiches de Révision</a
          >
        </li>
        <li class="nav-item nav-item-profile">
          <a class="nav-link" role="button" routerLinkActive="text-active" routerLink="/profile">Profil</a>
        </li>
        <li class="nav-item nav-item-profile">
          <button type="button" class="btn btn-outline-primary" (click)="logOut()">Déconnexion</button>
        </li>
      </ul>

      <ul class="navbar-nav navbar-right">
        <li ngbDropdown class="nav-item">
          <div type="button" class="account-group d-flex px-1 py-1 align-items-center" ngbDropdownToggle>
            <div class="material-symbols-outlined account-icon">account_circle</div>
            <em class="material-symbols-outlined px-0 mx-0">arrow_drop_down</em>
          </div>

          <div ngbDropdownMenu class="dropdown-menu dropdown-menu-end">
            <button routerLink="/profile" ngbDropdownItem>Profil</button>
            <div class="dropdown-divider"></div>
            <button (click)="logOut()" ngbDropdownItem>Déconnexion</button>
          </div>
        </li>
      </ul>
    </div>
  </div>
</nav>
